(function () {
  var SESSION_KEY = 'mf_loaded';
  if (sessionStorage.getItem(SESSION_KEY)) {
    var overlay = document.getElementById('forestmagic-loading');
    if (overlay) overlay.remove();
    return;
  }
  sessionStorage.setItem(SESSION_KEY, '1');

  var overlay = document.getElementById('forestmagic-loading');
  var canvas  = document.getElementById('forestmagic-loading-canvas');
  if (!overlay || !canvas) return;

  var ctx = canvas.getContext('2d');
  var W, H, particles = [], done = false;

  function resize() {
    W = canvas.width  = window.innerWidth;
    H = canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  /* Particle — floating dust mote */
  function Particle() {
    this.reset();
  }
  Particle.prototype.reset = function () {
    this.x = Math.random() * W;
    this.y = Math.random() * H;
    this.r = Math.random() * 1.4 + 0.3;
    this.vx = (Math.random() - 0.5) * 0.3;
    this.vy = -(Math.random() * 0.4 + 0.1);
    this.alpha = 0;
    this.maxAlpha = Math.random() * 0.5 + 0.1;
    this.life = 0;
    this.maxLife = Math.random() * 220 + 120;
    /* purple or dark-red tint */
    this.hue = Math.random() < 0.65 ? '106,13,173' : '139,0,0';
  };
  Particle.prototype.update = function () {
    this.life++;
    var t = this.life / this.maxLife;
    this.alpha = t < 0.2
      ? this.maxAlpha * (t / 0.2)
      : t > 0.75
        ? this.maxAlpha * (1 - (t - 0.75) / 0.25)
        : this.maxAlpha;
    this.x += this.vx;
    this.y += this.vy;
    if (this.life >= this.maxLife) this.reset();
  };
  Particle.prototype.draw = function () {
    ctx.save();
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(' + this.hue + ',' + this.alpha.toFixed(3) + ')';
    ctx.fill();
    ctx.restore();
  };

  /* Vine segment */
  function Vine(startX, startY, dir) {
    this.x = startX;
    this.y = startY;
    this.dir = dir; /* 1 = right, -1 = left */
    this.angle = dir > 0 ? -0.3 : Math.PI + 0.3;
    this.len = 0;
    this.maxLen = Math.random() * 120 + 80;
    this.speed = Math.random() * 1.2 + 0.6;
    this.alpha = 0;
    this.done = false;
    this.points = [{ x: startX, y: startY }];
  }
  Vine.prototype.update = function () {
    if (this.done) return;
    this.len += this.speed;
    this.angle += (Math.random() - 0.5) * 0.12;
    var last = this.points[this.points.length - 1];
    this.points.push({
      x: last.x + Math.cos(this.angle) * this.speed,
      y: last.y + Math.sin(this.angle) * this.speed * 0.6
    });
    this.alpha = Math.min(this.alpha + 0.015, 0.22);
    if (this.len >= this.maxLen) this.done = true;
  };
  Vine.prototype.draw = function () {
    if (this.points.length < 2) return;
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(this.points[0].x, this.points[0].y);
    for (var i = 1; i < this.points.length; i++) {
      ctx.lineTo(this.points[i].x, this.points[i].y);
    }
    ctx.strokeStyle = 'rgba(106,13,173,' + this.alpha.toFixed(3) + ')';
    ctx.lineWidth = 0.8;
    ctx.stroke();
    ctx.restore();
  };

  /* Init */
  var PARTICLE_COUNT = 60;
  for (var i = 0; i < PARTICLE_COUNT; i++) {
    var p = new Particle();
    p.life = Math.floor(Math.random() * p.maxLife); /* stagger */
    particles.push(p);
  }

  var vines = [];
  /* Spawn vines from bottom corners */
  setTimeout(function () {
    vines.push(new Vine(0, H, 1));
    vines.push(new Vine(W, H, -1));
  }, 400);
  setTimeout(function () {
    vines.push(new Vine(W * 0.15, H, 1));
    vines.push(new Vine(W * 0.85, H, -1));
  }, 900);

  function startFade() {
    overlay.classList.add('is-hidden');
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 1000);
  }

  function draw() {
    ctx.clearRect(0, 0, W, H);

    /* Vignette */
    var grad = ctx.createRadialGradient(W / 2, H / 2, H * 0.1, W / 2, H / 2, H * 0.85);
    grad.addColorStop(0, 'rgba(13,13,13,0)');
    grad.addColorStop(1, 'rgba(13,13,13,0.7)');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, W, H);

    vines.forEach(function (v) { v.update(); v.draw(); });
    particles.forEach(function (p) { p.update(); p.draw(); });

    if (!done) requestAnimationFrame(draw);
  }

  function start() {
    draw();
    /* Fade out after page load + small delay */
    window.addEventListener('load', function () {
      setTimeout(startFade, 2800);
    });
    /* Hard timeout fallback */
    setTimeout(startFade, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
